/**
 * 메시지 배열을 받아 지정한 키 값을 모두 삭제 한 메시지 배열을 반환
 * params : messages[{}, {}, {} ...], deleteKeys ["key1", "key2", "key3"]
 */
const deleteKeys = (messages, deleteKeys) => {

  messages = messages.map( message => {
    
    deleteKeys.map( key => {
      delete message[key];
      return key
    })

    const { components } = message;

    message = {
      ...message,
      components : deleteKeysForComponent(components, ["id", "updateID"]),
    }

    return message;
  });

  return messages;
}
const deleteKeysForComponent = (components, deleteKeys) => {
  components = components.map( component => {
    
    // Delete keys
    deleteKeys.map( key => {
      delete component[key];
      return key
    })

    // is Expandable Component
    // 일단 재귀형태
    if (component.hasOwnProperty("components")) {
      let { components } = component;
      components = deleteKeysForComponent(components, deleteKeys);

      component = {
        ...component,
        components : components,
      }
    }

    return component;
  });
  return components;
}


/**
 * 임시 필터링
 */
const deleteKeys_temp = (messages, deleteKeys) => {

  messages = messages.map( message => {
    
    deleteKeys.map( key => {
      delete message[key];
      return key
    })

    const { components } = message;

    message = {
      ...message,
      components : deleteKeysForComponent_temp(components, ["imageBinary"]),
    }

    return message;
  });

  return messages;
}
const deleteKeysForComponent_temp = (components, deleteKeys) => {
  components = components.map( component => {
    
    // Delete keys
    deleteKeys.map( key => {
      delete component[key];
      return key
    })

    // is Expandable Component
    // 일단 재귀형태
    if (component.hasOwnProperty("components")) {
      let { components } = component;
      components = deleteKeysForComponent(components, deleteKeys);

      component = {
        ...component,
        components : components,
      }
    }

    return component;
  });
  return components;
}

const mapObject2Array = (object) => {
  // 
  let result = [];
  if (object) {
    const keys = Object.keys(object);

    keys.map( key => {
      result = result.concat(object[key]);
      return key
    });
  }

  
  return result;
}

/**
 * 컴포넌트의 타입 문자열을 파싱하여 정형화된 데이터로 반환합니다.
 * @param {String} type_str 
 */
export const getType = (type_str) => {
  const slicedAttr = type_str.split('/')
  if (slicedAttr) {
    if (slicedAttr[0]) {
      // if (slicedAttr[0] === "NORMAL") {
      //   return {
      //     prefix : slicedAttr[0],
      //     type : slicedAttr[1]
      //   }
      // }
      return { 
        prefix : slicedAttr[0],
        type : slicedAttr[1]
      }
    }
  }
}

/**
 * 영문 레이아웃 문자열 데이터를 한글로 바꾸어줍니다.
 * @param {String} layout 
 */
export const translateLayout = (layout) => {
  switch(layout) {
    case 'default':
      return '기본'
    case 'slide':
      return '슬라이드'
    default:
      console.error('layout data ', layout, ' is cannot translate to KR')
      console.info('Return \'기본\'')
      return '기본'
  }
}

export {deleteKeys};
export {deleteKeys_temp};
export {mapObject2Array};